import { ITeamTab } from '../components/TeamTabEdit'
import { ManualRepostObject, RepostType } from '../const/RepostType'
import { isOrganizationsEntityType } from './prepareCustomSortingGridFilter'

export type CustomSortingCarrier = {
  entityType?: string
  customProjectSorting?: string[]
  customTeamsSorting?: string[]
  filter?: {
    projectIds?: string[]
    projectsShortInfos?: ManualRepostObject[]
  }
}

const normalizeIds = (ids?: string[]): string[] => (ids || []).filter(Boolean)

export const getCustomSortingIds = (
  carrier: CustomSortingCarrier | null | undefined,
  entityType?: string,
): string[] => {
  if (!carrier) {
    return []
  }

  const resolvedEntityType = entityType || carrier.entityType

  if (isOrganizationsEntityType(resolvedEntityType)) {
    return normalizeIds(carrier.customTeamsSorting)
  }

  return normalizeIds(
    carrier.customProjectSorting ?? carrier.filter?.projectsShortInfos?.map((item: ManualRepostObject) => item.projectId),
  )
}

export const applyCustomSortingToCarrier = <T extends CustomSortingCarrier>(
  carrier: T,
  ids: string[],
  entityType?: string,
): T => {
  const resolvedEntityType = entityType || carrier.entityType
  const normalizedIds = normalizeIds(ids)

  if (isOrganizationsEntityType(resolvedEntityType)) {
    return {
      ...carrier,
      customTeamsSorting: normalizedIds,
      customProjectSorting: undefined,
    } as T
  }

  return {
    ...carrier,
    customProjectSorting: normalizedIds,
    filter: {
      ...carrier.filter,
      projectsShortInfos: normalizedIds.map((projectId: string) => ({ projectId, addMethod: RepostType.manual })),
    },
  } as T
}

export const ensureExclusiveTabCustomSorting = (tabs: ITeamTab[]): ITeamTab[] => {
  const activeIndex = tabs.findIndex((tab) => tab.customSorting)
  if (activeIndex === -1) {
    return tabs
  }

  return tabs.map((tab, index) => {
    if (index === activeIndex || !tab.customSorting) {
      return tab
    }

    return { ...tab, customSorting: false }
  })
}

export const toggleExclusiveTabCustomSorting = (
  tabs: ITeamTab[],
  activeIndex: number,
): ITeamTab[] => {
  const isEnabling = !tabs[activeIndex]?.customSorting

  return tabs.map((tab, index) => {
    if (index === activeIndex) {
      return { ...tab, customSorting: isEnabling }
    }

    if (!isEnabling || !tab.customSorting) {
      return tab
    }

    return { ...tab, customSorting: false }
  })
}

export const setExclusiveTabCustomSorting = (
  tabs: ITeamTab[],
  activeIndex: number,
  nextTab: ITeamTab,
): ITeamTab[] => (
  tabs.map((tab, index) => {
    if (index === activeIndex) {
      return { ...nextTab, customSorting: true }
    }

    if (!tab.customSorting) {
      return tab
    }

    return { ...tab, customSorting: false }
  })
)

export const clearTabCustomSorting = (tabs: ITeamTab[]): ITeamTab[] => (
  tabs.map((tab) => (tab.customSorting ? { ...tab, customSorting: false } : tab))
)

export const applyCustomSortingToTeamUpdate = (
  teamRaw: Record<string, unknown>,
  ids: string[],
  entityType?: string,
  isTabFilter?: boolean,
  tabIndex?: number,
  options?: { organizationsCatalog?: boolean },
): void => {
  const normalizedIds = normalizeIds(ids)

  if (isTabFilter) {
    const tabs = Array.isArray(teamRaw.tabs) ? [...teamRaw.tabs] : []
    const idx = typeof tabIndex === 'number' ? tabIndex : 0
    const targetTab = tabs[idx]

    if (!targetTab) {
      return
    }

    const isOrganizationsCatalog = !!options?.organizationsCatalog
    const resolvedEntityType = entityType || (targetTab as CustomSortingCarrier).entityType
    const nextTab = applyCustomSortingToCarrier(
      {
        ...targetTab,
        ...(isOrganizationsCatalog ? {
          entityType: 'organizations',
          isProjectsView: true,
          customSorting: false,
        } : {
          customSorting: true,
        }),
      },
      normalizedIds,
      resolvedEntityType,
    )

    teamRaw.tabs = isOrganizationsCatalog
      ? tabs.map((tab, index) => (index === idx ? nextTab : tab))
      : setExclusiveTabCustomSorting(tabs, idx, nextTab)
    teamRaw.customSorting = isOrganizationsCatalog
    return
  }

  if (options?.organizationsCatalog && isOrganizationsEntityType(entityType)) {
    teamRaw.customSorting = true
    teamRaw.isProjectsView = true
    teamRaw.mainEntityType = 'organizations'
    teamRaw.customTeamsSorting = normalizedIds
    delete teamRaw.customProjectSorting
    if (Array.isArray(teamRaw.tabs)) {
      teamRaw.tabs = clearTabCustomSorting(teamRaw.tabs as ITeamTab[])
    }
    return
  }

  teamRaw.customSorting = true
  if (Array.isArray(teamRaw.tabs)) {
    teamRaw.tabs = clearTabCustomSorting(teamRaw.tabs as ITeamTab[])
  }

  if (isOrganizationsEntityType(entityType)) {
    teamRaw.customTeamsSorting = normalizedIds
    delete teamRaw.customProjectSorting
    return
  }

  teamRaw.customProjectSorting = normalizedIds
  delete teamRaw.customTeamsSorting
}
import { ITeamTab } from '../components/TeamTabEdit'
import { ManualRepostObject, RepostType } from '../const/RepostType'
import { isOrganizationsEntityType } from './prepareCustomSortingGridFilter'

export type CustomSortingCarrier = {
  entityType?: string
  customProjectSorting?: string[]
  customTeamsSorting?: string[]
  filter?: {
    projectIds?: string[]
    projectsShortInfos?: ManualRepostObject[]
  }
}

const normalizeIds = (ids?: string[]): string[] => (ids || []).filter(Boolean)

export const getCustomSortingIds = (
  carrier: CustomSortingCarrier | null | undefined,
  entityType?: string,
): string[] => {
  if (!carrier) {
    return []
  }

  const resolvedEntityType = entityType || carrier.entityType

  if (isOrganizationsEntityType(resolvedEntityType)) {
    return normalizeIds(carrier.customTeamsSorting)
  }

  return normalizeIds(
    carrier.customProjectSorting ?? carrier.filter?.projectsShortInfos?.map((item: ManualRepostObject) => item.projectId),
  )
}

export const applyCustomSortingToCarrier = <T extends CustomSortingCarrier>(
  carrier: T,
  ids: string[],
  entityType?: string,
): T => {
  const resolvedEntityType = entityType || carrier.entityType
  const normalizedIds = normalizeIds(ids)

  if (isOrganizationsEntityType(resolvedEntityType)) {
    return {
      ...carrier,
      customTeamsSorting: normalizedIds,
      customProjectSorting: undefined,
    } as T
  }

  return {
    ...carrier,
    customProjectSorting: normalizedIds,
    filter: {
      ...carrier.filter,
      projectsShortInfos: normalizedIds.map((projectId: string) => ({ projectId, addMethod: RepostType.manual })),
    },
  } as T
}

export const ensureExclusiveTabCustomSorting = (tabs: ITeamTab[]): ITeamTab[] => {
  const activeIndex = tabs.findIndex((tab) => tab.customSorting)
  if (activeIndex === -1) {
    return tabs
  }

  return tabs.map((tab, index) => {
    if (index === activeIndex || !tab.customSorting) {
      return tab
    }

    return { ...tab, customSorting: false }
  })
}

export const toggleExclusiveTabCustomSorting = (
  tabs: ITeamTab[],
  activeIndex: number,
): ITeamTab[] => {
  const isEnabling = !tabs[activeIndex]?.customSorting

  return tabs.map((tab, index) => {
    if (index === activeIndex) {
      return { ...tab, customSorting: isEnabling }
    }

    if (!isEnabling || !tab.customSorting) {
      return tab
    }

    return { ...tab, customSorting: false }
  })
}

export const setExclusiveTabCustomSorting = (
  tabs: ITeamTab[],
  activeIndex: number,
  nextTab: ITeamTab,
): ITeamTab[] => (
  tabs.map((tab, index) => {
    if (index === activeIndex) {
      return { ...nextTab, customSorting: true }
    }

    if (!tab.customSorting) {
      return tab
    }

    return { ...tab, customSorting: false }
  })
)

export const clearTabCustomSorting = (tabs: ITeamTab[]): ITeamTab[] => (
  tabs.map((tab) => (tab.customSorting ? { ...tab, customSorting: false } : tab))
)

export const applyCustomSortingToTeamUpdate = (
  teamRaw: Record<string, unknown>,
  ids: string[],
  entityType?: string,
  isTabFilter?: boolean,
  tabIndex?: number,
  options?: { organizationsCatalog?: boolean },
): void => {
  const normalizedIds = normalizeIds(ids)

  if (isTabFilter) {
    const tabs = Array.isArray(teamRaw.tabs) ? [...teamRaw.tabs] : []
    const idx = typeof tabIndex === 'number' ? tabIndex : 0
    const targetTab = tabs[idx]

    if (!targetTab) {
      return
    }

    const isOrganizationsCatalog = !!options?.organizationsCatalog
    const resolvedEntityType = entityType || (targetTab as CustomSortingCarrier).entityType
    const nextTab = applyCustomSortingToCarrier(
      {
        ...targetTab,
        ...(isOrganizationsCatalog ? {
          entityType: 'organizations',
          isProjectsView: true,
          customSorting: false,
        } : {
          customSorting: true,
        }),
      },
      normalizedIds,
      resolvedEntityType,
    )

    teamRaw.tabs = isOrganizationsCatalog
      ? tabs.map((tab, index) => (index === idx ? nextTab : tab))
      : setExclusiveTabCustomSorting(tabs, idx, nextTab)
    teamRaw.customSorting = isOrganizationsCatalog
    return
  }

  if (options?.organizationsCatalog && isOrganizationsEntityType(entityType)) {
    teamRaw.customSorting = true
    teamRaw.isProjectsView = true
    teamRaw.mainEntityType = 'organizations'
    teamRaw.customTeamsSorting = normalizedIds
    delete teamRaw.customProjectSorting
    if (Array.isArray(teamRaw.tabs)) {
      teamRaw.tabs = clearTabCustomSorting(teamRaw.tabs as ITeamTab[])
    }
    return
  }

  teamRaw.customSorting = true
  if (Array.isArray(teamRaw.tabs)) {
    teamRaw.tabs = clearTabCustomSorting(teamRaw.tabs as ITeamTab[])
  }

  if (isOrganizationsEntityType(entityType)) {
    teamRaw.customTeamsSorting = normalizedIds
    delete teamRaw.customProjectSorting
    return
  }

  teamRaw.customProjectSorting = normalizedIds
  delete teamRaw.customTeamsSorting
}
